<!-- Home button-->
<a [routerLink]="['/']"
  class="text-nav btn btn-icon bg-light border rounded-circle position-absolute top-0 end-0 zindex-2 p-0 mt-3 me-3 mt-sm-4 me-sm-4"
  ngbTooltip="Pagina principala"><i class="ai-home"></i>
</a>
